import { isSimulationRowInSegment, type FlowControlSegmentKind } from '@/helpers/simulation-cue-engine.helper';
import type { SimulationCueSheetRow } from '@/types/player/simulation-cue-sheet.types';

export function resolveFlowControlCueSegmentRows(
  rows: SimulationCueSheetRow[],
  slotId: string,
  segmentKind: FlowControlSegmentKind,
): SimulationCueSheetRow[] {
  return rows
    .filter(
      (row) =>
        isSimulationRowInSegment(row, 'slot', slotId, segmentKind) &&
        row.isPlayable !== false &&
        (row.presentationKind === 'composite' ||
          row.itemId.startsWith('virtualMedia:') ||
          row.itemId.startsWith('composite:')),
    )
    .sort((a, b) => a.ordinal - b.ordinal);
}
